import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'ms-game-not-found',
    imports: [CommonModule, TranslateModule],
    templateUrl: './game-not-found.component.html',
    styleUrls: ['./game-not-found.component.scss']
})
export class GameNotFoundComponent {

}
